// HTTP header constants used across the application
export const X_CL_APP_ACCT_USER_GUID = 'x-cl-app-acct-user-guid';
